import { useNavigate } from 'react-router-dom'
import { Auth0LoginButton } from 'grabbitbot-legacy-ui'
import { AUTH0_LOGIN_EXPECTED_ORIGIN, AUTH0_LOGIN_URL, POST_LOGIN_PATH } from '../../config'

// Equivalent of legacy `UserValidateComponent` (registration confirmation
// link). 2026-09-26 (owner decision, legacy-migration/RULES.md): `PATCH
// /user/validate` now returns `410` — Auth0 verifies e-mail addresses
// itself, so an old confirmation link landing here has nothing left to
// confirm. Kept registered and points at Auth0 sign-in.
export function RegisterValidatePage() {
  const navigate = useNavigate()
  return (
    <div className="screener-card screener-card--notice">
      <p role="alert">
        This confirmation link is no longer needed — e-mail confirmation now
        happens as part of signing in.
      </p>
      <Auth0LoginButton
        popupUrl={AUTH0_LOGIN_URL}
        expectedOrigin={AUTH0_LOGIN_EXPECTED_ORIGIN}
        onSuccess={() => navigate(POST_LOGIN_PATH, { replace: true })}
      >
        Log in
      </Auth0LoginButton>
    </div>
  )
}
